<template>
 <div class="cooperation">
    <slider animation="fade" :control-btn="false">
      <slider-item><img src="@/assets/images/qingsongzhuanqian.jpg" height="100%"></slider-item>
      <slider-item><img src="@/assets/images/xiaofeizhe.jpg" height="100%"></slider-item>
      <slider-item><img src="@/assets/images/qingsongdaili.jpg" height="100%"></slider-item>
    </slider>
    <div class="tabs" v-bind:class="{ active: tabFixed}">
      <div class="contentWidth clearfix">
        <div class="item recruitment" v-bind:class="{ active: activeId==0 }" v-on:click="tabShow(0)">
          门店招募
        </div>
        <div class="item agent" v-bind:class="{ active: activeId==1 }" v-on:click="tabShow(1)">
          县级代理
        </div>
        <div class="item partner" v-bind:class="{ active: activeId==2 }" v-on:click="tabShow(2)">
          合伙人
        </div>
      </div>
    </div>
    <div class="tabContent" id='tabContent' v-bind:class="{ active: tabFixed }">
      <div class="tabItem" v-show="showId==0">
          <div class="module rights">
            <div class="title">门店权益</div>
            <div class="contentWidth clearfix">
              <div class="item">
                <img src="@/assets/images/pinpaibaozhang_icon.png" width="337" height="390" />
                <h1>品牌有保障</h1>
                <p>羊村集团与全国知名大品牌合作，<br/>所售商品有品牌保障</p>
              </div>
              <div class="item">
                <img src="@/assets/images/jinhuoyouhui_icon.png" width="337" height="390" />
                <h1>进货有优惠</h1>
                <p>羊村集团合伙人均享有优惠的进货<br/>政策</p>
              </div>
              <div class="item">
                <img src="@/assets/images/jituandfuli_icon.png" width="337" height="390" />
                <h1>集团有福利</h1>
                <p>主要福利包括：消费者引流、消费<br/>者管理、平台一键订货、数据化智<br/>能运营</p>
              </div>
            </div>
          </div>
          <div class="module welfare">
            <div class="title">羊村提供福利</div>
            <div class="contentWidth clearfix welfare1">
              <div class="item">
                 <img src="@/assets/images/ic_xiaoshoupeixun.png"/>
                 <p>销售培训</p>
              </div>
              <div class="item">
                 <img src="@/assets/images/ic_Huodongfangan.png"/>
                 <p>活动方案支持</p>
              </div>
               <div class="item">
                 <img src="@/assets/images/ic_xiaoshoujiangli.png"/>
                 <p>销售奖励</p>
              </div>
              <div class="item">
                 <img src="@/assets/images/ic_cuxiao.png"/>
                 <p>促销费用支持</p>
              </div>
              <div class="item">
                 <img src="@/assets/images/ic_dashuju.png"/>
                 <p>大数据支持</p>
              </div>
              <div class="item">
                 <img src="@/assets/images/ic_mubiaodacheng.png"/>
                 <p>目标达成奖励</p>
              </div>
            </div>
          </div>
      </div>
      <div class="tabItem" v-show="showId==1">
          <div class="module rights">
            <div class="title">代理权益</div>
            <div class="contentWidth clearfix">
              <div class="item">
                <img src="@/assets/images/pinpaibaozhang_icon.png" width="337" height="390" />
                <h1>品牌有保障</h1>
                <p>羊村集团与全国知名大品牌合作，<br/>所售商品有品牌保障</p>
              </div>
              <div class="item">
                <img src="@/assets/images/jinhuoyouhui_icon.png" width="337" height="390" />
                <h1>进货有优惠</h1>
                <p>羊村集团合伙人均享有优惠的进货<br/>政策</p>
              </div>
              <div class="item">
                <img src="@/assets/images/jituandfuli_icon.png" width="337" height="390" />
                <h1>集团有福利</h1>
                <p>主要福利包括：消费者引流、消费<br/>者管理、平台一键订货、数据化智<br/>能运营</p>
              </div>
              <div class="item">
                <img src="@/assets/images/xiaoshoujiangli_ICON.png" width="337" height="390" />
                <h1>销售有奖励</h1>
                <p>羊村集团根据不同时期会发布不同<br/>活动政策，凡达到销售要求均会有<br/>相应奖励</p>
              </div>
            </div>
          </div>
          <div class="module welfare">
            <div class="title">羊村提供福利</div>
            <div class="contentWidth clearfix welfare2">
              <div class="item">
                 <img src="@/assets/images/ic_xiaoshoupeixun.png"/>
                 <p>销售培训</p>
              </div>
              <div class="item">
                 <img src="@/assets/images/ic_Huodongfangan.png"/>
                 <p>活动方案支持</p>
              </div>
              <div class="item">
                 <img src="@/assets/images/ic_cuxiao.png"/>
                 <p>促销费用支持</p>
              </div>
              <div class="item">
                 <img src="@/assets/images/ic_dashuju.png"/>
                 <p>大数据支持</p>
              </div>
              <div class="item">
                 <img src="@/assets/images/ic_mubiaodacheng.png"/>
                 <p>目标达成奖励</p>
              </div>
            </div>
          </div>
      </div>
      <div class="tabItem" v-show="showId==2">
          <div class="module rights">
            <div class="title">合伙人权益</div>
            <div class="contentWidth clearfix">
              <div class="item">
                <img src="@/assets/images/pinpaibaozhang_icon.png" width="337" height="390" />
                <h1>品牌有保障</h1>
                <p>羊村集团与全国知名大品牌合作，<br/>所售商品有品牌保障</p>
              </div>
              <div class="item">
                <img src="@/assets/images/jinhuoyouhui_icon.png" width="337" height="390" />
                <h1>进货有优惠</h1>
                <p>羊村集团合伙人均享有优惠的进货<br/>政策</p>
              </div>
              <div class="item">
                <img src="@/assets/images/jituandfuli_icon.png" width="337" height="390" />
                <h1>集团有福利</h1>
                <p>主要福利包括：消费者引流、消费<br/>者管理、平台一键订货、数据化智<br/>能运营</p>
              </div>
              <div class="item">
                <img src="@/assets/images/youxianxuanze_icon.png" width="337" height="390" />
                <h1>优先选择权</h1>
                <p>在羊村集团旗下新增大牌，合伙人<br/>享有对品牌的优先选择权</p>
              </div>
              <div class="item">
                <img src="@/assets/images/xiaoshoujiangli_ICON.png" width="337" height="390" />
                <h1>销售有奖励</h1>
                <p>羊村集团根据不同时期会发布不同<br/>活动政策，凡达到销售要求均会有<br/>相应奖励</p>
              </div>
              <div class="item">
                <img src="@/assets/images/gufenqiquan_icon.png" width="337" height="390" />
                <h1>股份期权与回购</h1>
                <p>羊村集团合伙人都可享有股份期权<br/>与回购权益</p>
              </div>
            </div>
          </div>
          <div class="module welfare">
            <div class="title">羊村提供福利</div>
            <div class="contentWidth clearfix welfare1">
              <div class="item">
                 <img src="@/assets/images/ic_xiaoshoupeixun.png"/>
                 <p>销售培训</p>
              </div>
              <div class="item">
                 <img src="@/assets/images/ic_Huodongfangan.png"/>
                 <p>活动方案支持</p>
              </div>
              <div class="item">
                 <img src="@/assets/images/ic_xiaoshoujiangli.png"/>
                 <p>销售奖励</p>
              </div>
               <div class="item">
                 <img src="@/assets/images/ic_xiaofeizhe.png"/>
                 <p>消费者数据</p>
              </div>
              <div class="item">
                 <img src="@/assets/images/ic_cuxiao.png"/>
                 <p>促销费用支持</p>
              </div>
              <div class="item">
                 <img src="@/assets/images/ic_dashuju.png"/>
                 <p>大数据支持</p>
              </div>
              <div class="item">
                 <img src="@/assets/images/ic_mubiaodacheng.png"/>
                 <p>目标达成奖励</p>
              </div>
            </div>
          </div>
      </div>
    </div>
 </div>
</template>

<script>
import { Slider, SliderItem } from 'vue-easy-slider'

export default {
  name: 'cooperation',
  data () {
    return {
      showId: 0,
      activeId: 0,
      tabFixed: false
    }
  },
  components: {
    Slider,
    SliderItem
  },
  methods: {
    tabShow (index) {
      this.showId = index
      this.activeId = index
    }
  },
  created () {
    var _this = this
    window.onscroll = function () {
      var tabTop = document.getElementById('tabContent').offsetTop
      var scrollTops = document.documentElement.scrollTop || document.body.scrollTop
      if (_this.tabFixed === true) {
        if (scrollTops >= tabTop) {
          _this.tabFixed = true
        } else {
          _this.tabFixed = false
        }
      } else {
        if (scrollTops >= tabTop - 117) {
          _this.tabFixed = true
        } else {
          _this.tabFixed = false
        }
      }
    }
  },
  destroyed () {
    window.onscroll = ''
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less' scoped>
.cooperation{
  .slider {
    width: 100% !important;
    height: 450px !important;
    min-width:1280px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .tabs{
    background-color: #fff;
    width:100%;
    padding-top: 38px;
    &.active{
      position: fixed;
      left: 0;
      top:0;
      padding: 20px 0;
      z-index: 1;
    }
    .contentWidth{
      position: relative;
      height:60px;
      .item{
        position: absolute;
        bottom: 0px;
        width:330px;
        height:59px;
        background: url(../assets/images/biankuang_tab.png) left center no-repeat;
        background-size: cover;
        text-align: center;
        line-height: 59px;
        color: #999;
        font-size: 20px;
        cursor: pointer;
        font-weight: bold;
        &:hover{
           background: url(../assets/images/tingliu_TAB.png) left center no-repeat;
           background-size: cover;
           color: #f95374;
        };
        &.active{
          background: url(../assets/images/xuanzhong_tab.png) left center no-repeat;
          background-size: cover;
          color: #fff;
        }
      }
      .recruitment{
        left:0px;
      }
      .agent{
        left: 384px;
      }
      .partner{
        left: 768px;
      }
    }
  }
  .tabContent{
    &.active{
      padding-top: 117px;
    }
  }
  .module{
   padding: 92px 0 35px 0;
    .title{
      text-align: center;
      font-size: 26px;
      color:#333;
      margin-bottom: 52px;
      background: url(../assets/images/line.png) bottom center no-repeat;
      padding-bottom: 22px;
    }
    &.rights{
      .item{
        width: 337px;
        float: left;
        position: relative;
        z-index: 0;
        text-align: center;
        margin-left: 44px;
        &:nth-child(n+4){
          margin-top: 33px;
        }
        &:nth-child(3n-2){
          margin-left: 0px;
        }
        h1{
          position: absolute;
          left: 0;
          top:220px;
          width: 100%;
          font-size: 20px;
          line-height: 20px;
        }
        p{
          position: absolute;
          width: 100%;
          left: 0;
          top:278px;
          font-size: 16px;
          height: 66px;
          line-height: 22px;
          overflow: hidden;
          color: #666
        }
      }
    }
    &.welfare{
      background-color: #fffbf5;
      text-align: center;
      .contentWidth{
        padding: 40px 0;
        .item{
          float: left;
          font-size: 16px;
          p{padding-top: 15px;}
        }
        &.welfare1{
          .item{
            margin-left: 201px;
            p{padding-top: 15px;}
            &:nth-child(4n-3){
              margin-left: 0;
            }
            &:nth-child(n+5){
              margin-top: 40px;
            }
          }
        }
        &.welfare2{
          .item{
            margin-left: 119px;
            &:nth-child(1){
              margin-left: 0;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cooperation.vue